import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import CreateNewStudents from './CreateNewStudents';
import EditStudent from './EditStudent';
import BulkUpdateBasic from './BulkUpdateBasic';
const StudentSetupLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'StudentSetup' */ './components/StudentSetup')
);

const PrintPagesLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'PrintPages' */ '@components/PrintPages/PrintPages'
		)
);

export default (store) => {
	return [
		{
			path: 'students-setup/:campusId?',
			element: <AsyncLoading component={<StudentSetupLazy />} />,
		},
		{
			path: 'students-setup/:campusId/print-pages',
			element: (
				<AsyncLoading
					component={<PrintPagesLazy permission="CanViewAdmissionSetup" />}
				/>
			),
		},
		CreateNewStudents(store),
		EditStudent(store),
		BulkUpdateBasic(store),
	];
};
